export default "__VITE_ASSET__DrWjNhbm__";